const agricultureView = (data) => {
    let formData = data && data.getAgricultureById && data.getAgricultureById.AgricultureFormData;
    if(formData){  
        let view = {
            name: formData.new_profile_agriculture_profile_name,
            sections: [
                {
                    name: 'Agricultural Business Information',
                    fields: [
                        {
                            number: 1,
                            label: 'Employer Name',
                            value: formData.new_profile_agriculture_emp_name,

                        },
                        {
                            number: 2,
                            label: 'Worksite Address',
                            value: formData.new_profile_agriculture_worksite_address,
                        },
                        {
                            number: 3,
                            label: 'City',
                            value: formData.new_profile_agriculture_city,
                        },
                        {
                            number: 4,
                            label: 'State',
                            value: formData.new_profile_agriculture_state,
                        },
                        {
                            number: 5,
                            label: 'County',
                            value: formData.new_profile_agriculture_county && formData.new_profile_agriculture_county.label,
                        },
                        {
                            number: 6,
                            label: 'Postal Code',
                            value: formData.new_profile_agriculture_zip,
                        },
                        {
                            number: 7,
                            label: 'Additional Place of Employment Information',
                            value: formData.new_profile_agriculture_add_emp_info,
                        }
                    ]
                }
            ]
        }
        return view;
    }
}

export default agricultureView;